<template>
  <div>
    <b-modal
      id="modal-upsert-api-key"
      :title="modalTitle"
      ok-title="Lưu"
      cancel-title="Hủy"
      @ok="onSubmit"
      :ok-disabled="isLoading"
      @close="reset"
    >
      <h5 class="mb-5">Thông tin chung</h5>

      <b-form-group>
        <label>Tên đối tác: <b class="text-danger">*</b></label>
        <b-form-input
          size="sm"
          v-model="data.partnerName"
          placeholder="Nhập tên đối tác"
          trim
        />
      </b-form-group>

      <b-form-group>
        <label>Mã đối tác: <b class="text-danger">*</b></label>
        <b-form-input
          size="sm"
          v-model="data.partnerCode"
          placeholder="Nhập mã đối tác"
          trim
        />
      </b-form-group>

      <b-form-group>
        <label>Mô tả:</label>
        <b-form-textarea
          size="sm"
          v-model="data.description"
          placeholder="Nhập mô tả"
        />
      </b-form-group>

      <b-form-group>
        <label>Trạng thái: <b class="text-danger">*</b></label>
        <b-form-checkbox
          size="md"
          v-model="data.status"
          name="check-button"
          switch
        >
          Đang hoạt động
        </b-form-checkbox>
      </b-form-group>

      <b-form-group>
        <label>Người dùng:</label>
        <div v-if="isLoadingUser">Đang tải thông tin người dùng...</div>
        <div v-else>
          <treeselect-extended
            key="userSelect"
            :options="employeeOptions"
            v-model="data.userId"
            placeholder="Chọn nhân viên áp dụng"
            no-results-text="Không có kết quả"
            :clearable="true"
            :searchable="true"
            :search-func="searchUsers"
            @new-node="addNewUser"
            @input="onUserChange"
          />
        </div>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { CreateApiKeyDto, UpdateApiKeyDto } from '@/view/pages/api-keys/models';
import ApiService from '@/core/services/api.service';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { showError } from '@/view/pages/api-keys/utils/common';
import TreeselectExtended from '@/view/components/common/TreeselectExtended.vue';

export default {
  props: ['id'],
  components: { TreeselectExtended },
  data() {
    return {
      isLoading: false,
      data: new CreateApiKeyDto({}),
      employeeOptions: [],
      isLoadingUser: false,
      selectedUser: null,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler: async function (value) {
        if (value) {
          await this.fetchData();
        } else {
          this.reset();
        }
      },
    },
  },
  methods: {
    async fetchData() {
      try {
        this.isLoadingUser = true;
        const response = await ApiService.get(`api-keys/${this.id}`);
        const resData = response.data.data;
        this.data = Object.assign({}, new UpdateApiKeyDto(resData));

        const userId = resData.user.id;

        const userResponse = await ApiService.get(`user/${userId}`);
        const userData = userResponse.data.data;

        const userObj = {
          id: userId,
          label: userData.employeeName,
        };

        this.employeeOptions = [userObj];
        this.selectedUser = userObj;

        this.data.userId = userId;
      } catch (error) {
        showError(error);
      } finally {
        this.isLoadingUser = false;
      }
    },

    fetchEmployees(searchQuery) {
      this.isLoading = true;
      
      const params = {
        page: 1,
        pageSize: 10,
        employeeName: searchQuery,
      };

      return ApiService.query('user', { params })
        .then((response) => {
          if (response.status) {
            const newEmployees = response.data.data.list_user.map(
              (employee) => ({
                id: employee.id,
                label: employee.employeeName,
              }),
            );

            this.employeeOptions = newEmployees;
            return newEmployees;
          }
        })
        .catch((error) => {
          console.error('Error fetching employees:', error);
          return this.employeeOptions;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    reset() {
      this.employeeOptions = [];
      this.$emit('closeModal');
      this.data = new CreateApiKeyDto({});
      this.selectedUser = null;
    },

    onSubmit(bvModelEvent) {
      bvModelEvent.preventDefault();
      this.isLoading = true;

      const request = this.id
        ? ApiService.put(`api-keys/${this.id}`, this.data)
        : ApiService.post('api-keys', this.data);

      request
        .then((response) => {
          if (response.status) {
            const msg = this.id
              ? 'Cập nhật tính năng thành công'
              : 'Tạo tính năng thành công';
            makeToastSuccess(msg);
            this.$bvModal.hide('modal-upsert-api-key');
            this.reset();
          }
        })
        .catch(() => {
          makeToastFaile('Có lỗi xảy ra');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onUserChange(value) {
      if (value !== 'new') {
        this.selectedUser = this.employeeOptions.find(
          (option) => option.id === value,
        );
      }
    },

    addNewUser({ value, id }) {
      const newUser = {
        id,
        label: value,
      };

      this.employeeOptions = [...this.employeeOptions, newUser];

      this.data.userId = id;
      this.selectedUser = newUser;

      return makeToastSuccess(`Đã thêm người dùng: ${value}`);
    },

    searchUsers(searchQuery) {
      return this.fetchEmployees(searchQuery);
    },
  },
  computed: {
    modalTitle() {
      return this.id ? 'Chỉnh sửa tính năng' : 'Thêm mới tính năng';
    },
  },
  mounted() {
    if (!this.id) {
      this.fetchEmployees('');
    }
  },
};
</script>
